import { buildMonetaryDetailSheet, toRows } from "./principle1DetailHelpers";

export const SHEET_NAME = "Penalty or fine";

export function buildPenaltyOrFineSheet(workbook, sectionC) {
  const essential = sectionC?.principle1?.essentialIndicators || {};
  return buildMonetaryDetailSheet(
    workbook,
    SHEET_NAME,
    "Details of penalty or fine",
    toRows(essential?.monetary?.penaltyFine)
  );
}
